import type { ReactNode } from 'react';

/**
 * Seção nomeada com caixa delimitada por borda.
 *
 * Usada para agrupar conteúdo semântico dentro de um card de questão,
 * como enunciado ou alternativas.
 *
 * @example
 * ```tsx
 * <QuestionSection label="Rótulo">
 *   <p dangerouslySetInnerHTML={{ __html: questionLabel }} />
 * </QuestionSection>
 * ```
 */
export interface QuestionSectionProps {
  /** Label exibido acima da caixa de conteúdo */
  readonly label: string;
  /** Conteúdo da seção */
  readonly children: ReactNode;
}

export function QuestionSection({ label, children }: QuestionSectionProps) {
  return (
    <div className="flex flex-col gap-nano">
      <span className="ts-heading-xxs text-ctx-content-title">{label}</span>
      <div className="rounded-sm border-hairline border-ctx-layout-border bg-ctx-layout-body p-micro">
        {children}
      </div>
    </div>
  );
}
